import React, { FC } from 'react';
import { graphql } from 'gatsby';

import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainContentWrapper,
  Title,
  Text,
  CardContainerDesktop,
  ContentContainerDesktop,
  ContentWrapper,
  CardImageWrapper,
  CardImage,
  CardTitle,
  CardText,
  CardContainerTablet,
  CardWrapperTablet,
  ContentContainerTabletFirstRow,
  ContentContainerTabletSecondRow,
  CardContainerMobile,
  ContentContainerMobile,
  ContentWrapperMobile,
  CardImageWrapperMobile,
} from './styled';

interface Props {
  // hasScrolled: boolean
}

const WhyHome: FC<Props & Queries.SeoWhyHomeFragment> = ({
  whyHome,
}) => {
  const { title, subtitle, steps } = whyHome || {};

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainContentWrapper>
            <Title>{title}</Title>
            <Text>{subtitle}</Text>
          </MainContentWrapper>
          {steps && (
            <CardContainerDesktop>
              {steps.map(step => (
                <ContentContainerDesktop key={step?.title}>
                  <ContentWrapper>
                    <CardImageWrapper>
                      <CardImage
                        src={step?.image?.src ?? undefined}
                        alt={step?.image?.alt ?? undefined}
                        width={60}
                        height={60}
                      />
                    </CardImageWrapper>
                    <CardTitle>{step?.title}</CardTitle>
                    <CardText>{step?.description}</CardText>
                  </ContentWrapper>
                </ContentContainerDesktop>
              ))}
            </CardContainerDesktop>
          )}
          {steps && (
            <CardContainerTablet>
              <CardWrapperTablet>
                {steps.slice(0, 3).map(step => (
                  <ContentContainerTabletFirstRow key={step?.title}>
                    <ContentWrapper>
                      <CardImageWrapper>
                        <CardImage
                          src={step?.image?.src ?? undefined}
                          alt={step?.image?.alt ?? undefined}
                          width={48}
                          height={48}
                        />
                      </CardImageWrapper>
                      <CardTitle>{step?.title}</CardTitle>
                      <CardText>{step?.description}</CardText>
                    </ContentWrapper>
                  </ContentContainerTabletFirstRow>
                ))}
              </CardWrapperTablet>
              <CardWrapperTablet>
                {steps.slice(3, 5).map(step => (
                  <ContentContainerTabletSecondRow key={step?.title}>
                    <ContentWrapper>
                      <CardImageWrapper>
                        <CardImage
                          src={step?.image?.src ?? undefined}
                          alt={step?.image?.alt ?? undefined}
                          width={48}
                          height={48}
                        />
                      </CardImageWrapper>
                      <CardTitle>{step?.title}</CardTitle>
                      <CardText>{step?.description}</CardText>
                    </ContentWrapper>
                  </ContentContainerTabletSecondRow>
                ))}
              </CardWrapperTablet>
            </CardContainerTablet>
          )}
          {steps && (
            <CardContainerMobile>
              {steps.map(step => (
                <ContentContainerMobile key={step?.title}>
                  <ContentWrapper>
                    <ContentWrapperMobile>
                      <CardImageWrapperMobile>
                        <CardImage
                          src={step?.image?.src ?? undefined}
                          alt={step?.image?.alt ?? undefined}
                          width={40}
                          height={40}
                        />
                      </CardImageWrapperMobile>
                      <CardTitle>{step?.title}</CardTitle>
                    </ContentWrapperMobile>
                    <CardText>{step?.description}</CardText>
                  </ContentWrapper>
                </ContentContainerMobile>
              ))}
            </CardContainerMobile>
          )}
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export const query = graphql`
  fragment SeoWhyHome on Json {
    whyHome {
      title
      subtitle
      steps {
        title
        description
        image {
          src
          alt
        }
      }
    }
  }
`;

export default WhyHome;
